import { createLexicalTextEditor } from 'modules/Lexical/editors';
import { $applyBrandStyle } from 'modules/Lexical/lexicalUtils';
import * as Models from 'models';

export const applyBrandStyleOnComponent = (
  textComponent: Models.TextComponent,
  brandStyleToApply: Models.BrandStyleMap,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList): Models.TextComponent => {
  const { lexicalState } = textComponent;
  if (!lexicalState) {
    return textComponent;
  }

  const editor = createLexicalTextEditor(lexicalState);
  editor.update(() => {
    $applyBrandStyle(brandStyleToApply, colors, fonts);
  }, { discrete: true });

  return { ...textComponent, lexicalState: JSON.stringify(editor.getEditorState()) };
};
